import React from "react";
import { useTranslation } from "../../localization/useTranslation";
import { useProcessingActivityCountWidgetProps } from "./ProcessingActivityCountWiget.hooks";
import DashboardCountCard from "../DashboardCountCard";
import Widget from "../Widget";
import { useUrlProvider } from "../../useUrlProvider";
import { Box } from "@mui/material";
import { processingActivityAllOnlyUserSpecificStorageKey } from "../../processingActivity/processingActivities/LegacyProcessingActivities.hooks";
import { setFirstLetterToLowerCase } from "../../common/stringOperations";
import LargeCountText from "../LargeCountText.tsx";
import SmallCountText from "../SmallCountText.tsx";
import CircularProgressWithLabel from "@common/components/circularProgressWithLabel/CircularProgressWithLabel";

export interface ProcessingActivityCountWigetProps {
    onlyUserSpecific: boolean;
    selectedGroupCompany: string | undefined;
    isPdf?: boolean;
}

function ProcessingActivityCountWiget(props: ProcessingActivityCountWigetProps) {
    const { translateString } = useTranslation();
    const { getProcessingActivitiesOverviewUrl } = useUrlProvider();
    const { isLoading, data, isEnabled } = useProcessingActivityCountWidgetProps(props);

    const noOfCompletedPas = data?.rows?.filter((x) => x.progressScore === 100)?.length ?? 0;

    return (
        <Widget noPadding disabled={!isEnabled}>
            <DashboardCountCard
                isLoading={isLoading}
                header={translateString("processingActivities")}
                background="darkblue"
                url={{
                    url: getProcessingActivitiesOverviewUrl(),
                    text: translateString("goToProcessingActivities"),
                    allMyPageKey: processingActivityAllOnlyUserSpecificStorageKey,
                    onlyUserSpecific: props.onlyUserSpecific,
                }}
                topRightElement={isLoading ? <></> : <CircularProgressWithLabel value={data?.overallProgress ?? 0} />}
                isPdf={props.isPdf}
            >
                {!isLoading && (
                    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
                        <LargeCountText count={noOfCompletedPas} />
                        <SmallCountText>/</SmallCountText>
                        <SmallCountText>{data?.rows.length}</SmallCountText>
                        <SmallCountText>
                            {setFirstLetterToLowerCase(noOfCompletedPas < 2 ? translateString("completed") : translateString("completedPlural"))}
                        </SmallCountText>
                    </Box>
                )}
            </DashboardCountCard>
        </Widget>
    );
}

export default ProcessingActivityCountWiget;
